/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleCheck = createReactComponent("circle-check", "IconCircleCheck", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 12l2 2l4 -4", key: "svg-1" }]
]);

export { IconCircleCheck as default };
//# sourceMappingURL=IconCircleCheck.js.map
